import { render, staticRenderFns } from "./ViewAssigned.vue?vue&type=template&id=069142fc&"
import script from "./ViewAssigned.vue?vue&type=script&lang=js&"
export * from "./ViewAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports